module.exports = __webpack_public_path__ + "static/media/game-over-sound.257f2a7e.wav";